export default "__VITE_ASSET__77f7e837__"